import React, { useState, useEffect } from 'react';
import KenCard from '../../global_components/KenCard';
import KenGrid from '../../global_components/KenGrid';
import KenDialog from '../../global_components/KenDialogBox';
import KenSelectWrap from '../../global_components/KenSelect';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import feedback from './FeedBack.json';
import KenSnackbar from '../../Components/KenSnackbar/index';
import './Feedback.css';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';

import {
  getFacultyAndFacilty,
  filterSessionAddData,
  filterSessionDeleteData,
} from '../../Utils/apiServices';
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import KenButton from '../../global_components/KenButton';

const FeedbackGrid = ({
  SelectedID,
  value,
  CourseID,
  sessionData,
  setReCallAPI,
}) => {
  const [showData, setshowData] = useState(true);
  var now = new Date();
  const [data, setData] = useState([]);
  const [Columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [addMode, setAddMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [masterDialog, setMasterDialog] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [sessionFeedbackSetupId, setsessionFeedbackSetupId] = useState('');

  const [dateChecked, setDateChecked] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [filterParamters, setfilterParamters] = useState('');

  const [selected, setSelected] = useState([]);
  console.log('selectedselectedselected', selected);
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const createFeedback = (id) => {
    setSessionId(id);
    setSelected([]);
    setEditMode(false);
    setViewMode(false);
    setMasterDialog(true);
  };
  const editFeedback = (id, data) => {
    setSessionId(id);
    setsessionFeedbackSetupId(data.sessionFeedbackSetupId);
    const feedbackPara = data.feedBackParameters.split(';').map((options) => {
      return {
        label: options,
        value: options,
      };
    });
    setSelected(feedbackPara);
    setEditMode(false);
    setViewMode(true);
    setMasterDialog(true);
  };
  const deleteFeedback = (itemsId, data) => {
    const deleteData = {
      Operation: 'Delete',
      SessionFeedbackSetup: [
        {
          sessionFeedbackSetupId: data.sessionFeedbackSetupId,
        },
      ],
    };
    filterSessionDeleteData(deleteData)
      .then((res) => {
        if (res.SessionFeedbackSetup[0].success === 'true') {
          setAddMode(true);
          setReCallAPI(true);
          setsessionFeedbackSetupId('');
        }
      })
      .catch((error) => {
        handleSnackbarOpen('error', error.message);
      });
  };

  useEffect(() => {
    if (value === 0) {
      setshowData(true);
      const filterData = [];
      sessionData &&
        sessionData.length > 0 &&
        sessionData.map((items) => {
          setDateChecked(moment(items.startDate).format('DD-MM-YYYY'));
          filterData.push({
            Name: items.sessionName,
            'Start Time': moment(items.startDate).format('HH:mm'),
            'End Time': moment(items.endDate).format('HH:mm'),
            Date: moment(items.startDate).format('DD-MM-YYYY'),
            Action: (
              <>
                {items?.SessionFeedBackSetup?.feedBackParameters === '' ||
                items?.SessionFeedBackSetup === null ? (
                  <KenButton
                    onClick={() => createFeedback(items.id)}
                    variant="primary"
                    label={<Typography>Create</Typography>}
                  />
                ) : new Date(items.startDate).getTime() <
                  new Date(moment()).getTime() ? (
                  <>
                    <KenButton
                      onClick={() =>
                        editFeedback(items.id, items.SessionFeedBackSetup)
                      }
                      variant="primary"
                      label={<Typography> View</Typography>}
                    />
                    <KenButton
                      onClick={() =>
                        deleteFeedback(items.id, items.SessionFeedBackSetup)
                      }
                      variant="primary"
                      label={<Typography> Delete</Typography>}
                      style={{ marginLeft: '10px' }}
                    />
                  </>
                ) : (
                  <KenButton
                    onClick={() =>
                      editFeedback(items.id, items.SessionFeedBackSetup)
                    }
                    variant="primary"
                    label={<Typography> View / Edit</Typography>}
                  />
                )}
              </>
            ),
          });
        });
      setData(filterData);

      const feedbackColums = [];
      feedback.feedbackColumns.map((colums) => {
        feedbackColums.push({
          Header: colums.name,
          accessor: colums.name,
          disableGlobalFilter: false,
        });
      });
      setColumns(feedbackColums);
    }
  }, [CourseID, SelectedID, value, addMode, editMode, sessionData]);
  useEffect(() => {
    getFacultyAndFacilty()
      .then((res) => {
        var feedbackparamters = [];
        res.FeedBackParameter.map((feedback) => {
          feedbackparamters.push({
            label: feedback.label,
            value: feedback.value,
          });
        });
        setfilterParamters(feedbackparamters);
      })
      .catch((error) => {
        handleSnackbarOpen('error', error.message);
      });
  }, []);

  const handleAddOptions = () => {
    const feedbackPara = selected.map((option) => {
      return option.value;
    });
    const filterAddData = {
      Operation: 'Create',
      SessionFeedbackSetup: [
        {
          sessionFeedbackSetupId: sessionFeedbackSetupId
            ? sessionFeedbackSetupId
            : '',
          sessionId: sessionId,
          feedBackParameters: feedbackPara.join(';'),
        },
      ],
    };
    filterSessionAddData(filterAddData)
      .then((res) => {
        if (res.SessionFeedbackSetup[0].success === 'true') {
          setAddMode(true);
          setReCallAPI(true);
          setMasterDialog(false);
        }
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
      });
  };

  useEffect(() => {
    if (editMode) {
      setViewMode(false);
    }
  }, [editMode]);
  return (
    <div>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <KenDialog
        title={
          viewMode === false ? (
            editMode === true ? (
              <Typography variant="h6">Edit feedback</Typography>
            ) : (
              <Typography variant="h6">Add feedback</Typography>
            )
          ) : (
            <Typography variant="h6">View Feedback</Typography>
          )
        }
        open={masterDialog}
        handleClose={() => setMasterDialog(false)}
        negativeButtonClick={() => {
          setMasterDialog(false);
        }}
        positiveButtonClick={() => {
          if (viewMode === true) {
            setMasterDialog(false);
          } else {
            handleAddOptions();
          }
        }}
        maxWidth={'md'}
        positiveButtonText={'Save'}
        negativeButtonText="Cancel"
        viewMode={viewMode}
        dateChecked={dateChecked}
        setEditMode={setEditMode}
        feedbackBody={true}
        dividers
      >
        <Grid container spacing={2} className="custom-select-box">
          <Grid item xs={6}>
            {viewMode === true && (
              <>
                <p style={{ fontSize: '1rem', fontWeight: '400' }}>
                  Parameters:
                </p>
                <List component="nav" aria-label="contacts">
                  {selected.length > 0 &&
                    selected.map((option) => {
                      return (
                        <>
                          <ListItem className="optionList">
                            <ListItemText primary={option.value} />
                          </ListItem>
                        </>
                      );
                    })}
                </List>
              </>
            )}

            {viewMode === false && editMode === false && (
              <>
                <MultiSelect
                  options={filterParamters}
                  value={selected}
                  onChange={setSelected}
                  hasSelectAll={false}
                  isCreatable={true}
                  disableSearch={true}
                />
              </>
            )}
            {editMode === true && (
              <>
                <MultiSelect
                  options={filterParamters}
                  value={selected}
                  onChange={setSelected}
                  hasSelectAll={false}
                  isCreatable={true}
                  disableSearch={true}
                />
              </>
            )}
          </Grid>
          {viewMode === false && (
            <Grid item xs={6}>
              <p style={{ fontSize: '12px', fontWeight: '400' }}>
                Selected Parameters:
              </p>
              <List component="nav" aria-label="contacts">
                {selected.length > 0 &&
                  selected.map((option) => {
                    return (
                      <>
                        <ListItem className="optionList">
                          <ListItemIcon>
                            <FiberManualRecordIcon />
                          </ListItemIcon>
                          <ListItemText primary={option.value} />
                        </ListItem>
                      </>
                    );
                  })}
              </List>
            </Grid>
          )}
        </Grid>
      </KenDialog>
      {showData && (
        <div className="feedbackMainDiv">
          <KenCard elevation={0}>
            <KenGrid
              columns={Columns}
              data={data}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
            />
          </KenCard>
        </div>
      )}
    </div>
  );
};

export default FeedbackGrid;
